import { marked } from 'marked';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { InfoMessage } from '@shared/components/Toast/InfoMessage/InfoMessage.tsx';
import { i18nNameSpace } from '@shared/consts/i18n.ts';

interface CopyToClipboardOptions {
  isMarkdown?: boolean;
}

export function useCopyToClipboard() {
  const { t } = useTranslation(i18nNameSpace.COMMON);

  const handleCopyClick = async (text: string, options: CopyToClipboardOptions = {}) => {
    const { isMarkdown = false } = options;

    try {
      if (isMarkdown && navigator.clipboard.write) {
        const htmlContent = await marked.parse(text);

        const blob = new Blob([htmlContent], { type: 'text/html' });
        const data = [
          new ClipboardItem({
            'text/html': blob,
            'text/plain': new Blob([text], { type: 'text/plain' }),
          }),
        ];

        await navigator.clipboard.write(data);
      } else {
        await navigator.clipboard.writeText(text);
      }

      toast.info(<InfoMessage message={t('infoMessages.copyToClipboard')} />);
    } catch (error) {
      console.warn('Failed to copy to clipboard:', error);

      try {
        await navigator.clipboard.writeText(text);
        toast.info(<InfoMessage message={t('infoMessages.copyToClipboard')} />);
      } catch (fallbackError) {
        console.warn('Fallback copy failed:', fallbackError);
        toast.error(<InfoMessage message={t('infoMessages.copyToClipboardError')} />);
      }
    }
  };

  return { handleCopyClick };
}
